import React from 'react';
import { Button, Message, ButtonGroup } from '../../Core';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'Data/ReduxViewModels/EquipmentInterfacing';
import { RootState } from 'Data/Redux';
import './InterfaceConnectionButtons.scss';
import { isWebSerialApiSupported } from 'Lib/WebSerialApi/helpers';

interface InterfaceConnectionButtonsProps {
  equipment: any;
  equipmentType: string;
}

/**
 * Buttons that let the user connect/disconnect the given equipment item
 */
let InterfaceConnectionButtons: React.FC<InterfaceConnectionButtonsProps> = ({ equipment, equipmentType }) => {
  const dispatch = useDispatch();
  const equipmentId = equipment?.Id;

  const isConnected = useSelector(
    (state: RootState) => state.equipmentInterfacing.equipment[equipmentId]?.isConnected ?? false
  );
  const isConnectInProgress = useSelector(
    (state: RootState) => state.equipmentInterfacing.equipment[equipmentId]?.connect.isInProgress
  );
  const isDisconnectInProgress = useSelector(
    (state: RootState) => state.equipmentInterfacing.equipment[equipmentId]?.disconnect.isInProgress
  );

  const requestPort = (equipmentId: string) => {
    dispatch(
      actions.requestPort({
        equipmentId,
        options: {
          baudRate: equipment?.PortSettings?.BaudRate,
          dataBits: equipment?.PortSettings?.DataBits,
          stopBits: equipment?.PortSettings?.StopBits,
          parity: equipment?.PortSettings?.Parity?.toLowerCase(),
        },
        equipmentData: {
          type: equipmentType,
          code: equipment?.Code,
          expectedComPort: equipment?.PortSettings?.ConnectedComPort,
        },
      })
    );
  };

  const unregisterPort = (equipmentId: string) => {
    dispatch(actions.unregisterPort({ equipmentId }));
  };

  return (
    <div className="InterfaceConnectionButtons">
      {isWebSerialApiSupported() ? (
        <ButtonGroup>
          <Button
            primary
            onClick={() => requestPort(equipmentId)}
            disabled={isConnected || !equipment?.Driver || !equipment?.PortSettings?.IsValidPortSettings}
            visible={!isConnected}
            loading={isConnectInProgress}
          >
            Connect
          </Button>
          <Button
            primary
            onClick={() => unregisterPort(equipmentId)}
            loading={isDisconnectInProgress}
            visible={isConnected}
            disabled={!isConnected}
          >
            Disconnect
          </Button>
        </ButtonGroup>
      ) : (
        <Message
          severity={'error'}
          message={'This browser does not support the Web Serial API. Please use Google Chrome to access this feature.'}
          border={false}
        />
      )}
    </div>
  );
};

InterfaceConnectionButtons = withInjectedProps(InterfaceConnectionButtons);

export { InterfaceConnectionButtons };
export default InterfaceConnectionButtons;
